export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_04.7792bed3.jpg";